// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	LessThanInput: 'less-than-input',
	GreaterThanInput: 'greater-than-input',
	FeeAmountSelect: 'fee-amount-select',
	DirectionOfAmountOption: 'direction-of-amount-option',
} as const;
